/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A free, full-screen ${i?.label} countdown with an alarm. Press Start and it counts down from ${i?.label}; when it reaches zero, the alarm sounds.`)
};

const es_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una cuenta regresiva de ${i?.label} gratis, a pantalla completa y con alarma. Presiona Iniciar y cuenta regresivamente desde ${i?.label}; cuando llega a cero, suena la alarma.`)
};

const de_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein kostenloser ${i?.label}-Countdown im Vollbild mit Alarm. Drücke Start, und er zählt von ${i?.label} herunter; erreicht er null, ertönt der Alarm.`)
};

const nl_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Een gratis, schermvullende ${i?.label}-aftelling met alarm. Druk op Start en de timer telt af vanaf ${i?.label}; als hij nul bereikt, klinkt het alarm.`)
};

const fr_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un compte à rebours ${i?.label} gratuit et plein écran, avec alarme. Appuyez sur Démarrer et il décompte à partir de ${i?.label} ; une fois arrivé à zéro, l’alarme retentit.`)
};

const it_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un countdown ${i?.label} gratuito a schermo intero con allarme. Premi Avvia e il conteggio parte da ${i?.label}; quando arriva a zero, suona l'allarme.`)
};

const pt_br2_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma contagem regressiva de ${i?.label} grátis, em tela cheia, com alarme. Pressione Iniciar e ela conta regressivamente a partir de ${i?.label}; quando chega a zero, o alarme toca.`)
};

const pt_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma contagem decrescente de ${i?.label} gratuita, em ecrã inteiro, com alarme. Prima Iniciar e a contagem decorre a partir de ${i?.label}; quando chega a zero, o alarme toca.`)
};

const ja_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アラーム付きの無料な全画面${i?.label}カウントダウン。スタートを押すと${i?.label}からカウントダウンが始まり、0になるとアラームが鳴ります。`)
};

const zh_timer_preset_intro = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费全屏${i?.label}倒计时，带闹铃提醒。点击开始即从${i?.label}开始倒计时；归零时闹铃会响起。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_intro = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_intro", locale)
	if (locale === "en") return en_timer_preset_intro(inputs)
	if (locale === "es") return es_timer_preset_intro(inputs)
	if (locale === "de") return de_timer_preset_intro(inputs)
	if (locale === "nl") return nl_timer_preset_intro(inputs)
	if (locale === "fr") return fr_timer_preset_intro(inputs)
	if (locale === "it") return it_timer_preset_intro(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_intro(inputs)
	if (locale === "pt") return pt_timer_preset_intro(inputs)
	if (locale === "ja") return ja_timer_preset_intro(inputs)
	return zh_timer_preset_intro(inputs)
};